<div class="logs-dial-container">
  @if (jobId !== -1) {
    <div class="header">Logs from Job ID: {{ this.jobId }}</div>
  }
  @if (jobId === -1) {
    <div class="header">Logs</div>
  }
  <div class="logs-container">
    <pre class="logs-pre">
      @for (line of logs; track line) {
        <span [ngClass]="{
          'log-error': line.message.toLowerCase().includes('error') || line.message.toLowerCase().includes('not available'),
          'log-success': line.message.toLowerCase().includes('success')
        }">{{ line.message }}</span>
      }
    </pre>
  </div>
  <div class="modal-actions">
    <button mat-stroked-button color="primary" style="color: #e3e3e3" (click)="onCopyLogs()">
      <mat-icon>content_copy</mat-icon>
      Copy to clipboard
    </button>
    <button mat-stroked-button color="primary" style="color: #e3e3e3" (click)="onClose()">
      <mat-icon>close</mat-icon>
      Close
    </button>
  </div>
</div>
